import React from 'react';
import PropTypes from 'prop-types';
import { Auth } from '@aws-amplify/auth';
import ResaleTicketsBanner from '../../sso/components/forms/resale-tickets-banner/ResaleTicketsBanner';

class TicketResaleBannerSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userAccountData: {}
        };

        this.refreshResaleComponent = this.refreshResaleComponent.bind(this);
    }

    componentDidMount() {
        this.refreshResaleComponent();
    }

    refreshResaleComponent() {
        Auth.currentAuthenticatedUser()
            .then((user) => {
                this.setState({ userAccountData: user });
            })
            .catch(() => {
            });
    }

    render() {
        const {
            resaleTicketSettings,
            ctaLoginLabel,
            ctaLoginStyle,
            ctaFirstLabel,
            ctaFirstStyle,
            ctaSecondLabel,
            ctaSecondStyle
        } = this.props;

        return (
            <ResaleTicketsBanner
                resaleTicketSettings={resaleTicketSettings}
                accountData={this.state.userAccountData}
                ctaLoginLabel={ctaLoginLabel}
                ctaLoginStyle={ctaLoginStyle}
                ctaFirstLabel={ctaFirstLabel}
                ctaFirstStyle={ctaFirstStyle}
                ctaSecondLabel={ctaSecondLabel}
                ctaSecondStyle={ctaSecondStyle}
            />
        );
    }
}

TicketResaleBannerSection.propTypes = {
    resaleTicketSettings: PropTypes.object,
    ctaLoginLabel: PropTypes.string,
    ctaLoginStyle: PropTypes.string,
    ctaFirstLabel: PropTypes.string,
    ctaFirstStyle: PropTypes.string,
    ctaSecondLabel: PropTypes.string,
    ctaSecondStyle: PropTypes.string,
};

export default TicketResaleBannerSection;
